<!DOCTYPE html>
@if (isSelectedSystem()) {
<form [formGroup]="registerForm" name="otsc-agent-register-form" (ngSubmit)="registerSystem()">
  @if (!selectedSystem.isOnline) {
  <div class="ot-row">
    <div id="register-system-error" class="ot-message ot-message--is-error" style="width: 100%;">
      <div class="ot-message__banner">
        <p class="ot-message__item" i18n>
          The agent must be running in order to be registered.
        </p>
      </div>
    </div>
  </div>
  }
  <div class="ot-mb-1 ot-ml-1 ot-mr-1">
    <div class="ot-level">
      <div class="ot-level__left">
        <h2>Registering system '{{selectedSystem.systemName}}'</h2>
      </div>
      <div class="ot-level__right">
        <div role="group" class="ot-btn-group">
          <button id="register-system-register-btn" class="ot-btn ot-btn--is-primary"
            [disabled]="!registerForm.valid || isRegistering || selectedEnvironment.length == 0" type="submit"
            title="Register" i18n>Register</button>
          <button id="register-system-cancel-btn" class="ot-btn ot-btn--is-secondary" (click)="cancel()" i18n-title
            title="Cancel" i18n>Cancel</button>
        </div>
      </div>
      <div>
        <div class="ot-row">
          <span id="register-system-warning-icon" class=" ot-list__icon ot-icon ot-icon--is-24x24"
            style="align-items: center;"><img src="./assets/icons/status_outdated24.svg" class="ot-dropdown__icon"
              alt="warning" i18n-alt></span>
          <div id="register-system-warning-text" class="col-md-11" style="padding: 10px;" i18n>Please, read it
            carefully!</div>
        </div>
        <div class="ot-row">
          <p id="register-system-message" class="col-md-12" i18n>An agent is requesting your approval to be registered.
            The agent is
            responsible to
            perform required tasks in this system in order to keep your OpenText products up-to-date. Before
            you
            execute any action, make sure you have a full backup of your environment. The name and
            description fields below can be defined to identify your system in the
            environment. After the system is registered, it will start collecting information about
            installed OpenText products. This process may take a few minutes to complete.</p>
        </div>
      </div>
      <div class="h-100 w-100" [ngStyle]="{'height': height}">
        <ng-scrollbar #scrollbarRef>
          <div class="ot-row">
            <div class="ot-row__column ot-row__column--is-40">
              <div class="ot-form-control ot-mr-1"
                [ngClass]="{'ot-form-control--is-invalid' : nameFormCtrl.touched && nameFormCtrl.invalid}">
                <label for="register-system-name" class="ot-form-control__label">
                  <span class="ot-form-control--is-required">*</span>
                  <span i18n>Name</span>
                </label>
                <input id="register-system-name" name="systemName" formControlName="nameFormCtrl" i18n-placeholder
                  placeholder="System Name" type="text" class="ot-input" maxlength="50">
                @if (nameFormCtrl.errors && nameFormCtrl.errors.required) {
                <p id="register-system-name-error-empty" class="ot-form-control__error-text" i18n autocomplete="off">
                  Name cannot be empty.
                </p>
                }
                @if (nameFormCtrl.errors && nameFormCtrl.errors.agentNameExists) {
                <p id="register-system-name-error-exists" class="ot-form-control__error-text" i18n autocomplete="off">
                  Name already exists.
                </p>
                }
              </div>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-row__column ot-row__column--is-40">
              <div class="ot-form-control ot-mr-1">
                <label for="register-system-description" class="ot-form-control__label" i18n>Description</label>
                <textarea class="ot-textarea" rows="3" formControlName="descriptionFormCtrl"
                  style="width:400px;height:40px;" minlength="1" maxlength="300" id="register-system-description"
                  [value]="description" i18n-placeholder placeholder="System description"></textarea>
              </div>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-row__column ot-row__column--is-40">
              <div class="ot-form-control ot-mb-0">
                <label for="register-system-environment" class="ot-form-control__label">
                  <span class="ot-form-control--is-required">*</span>
                  <span i18n>Select an environment to register a system</span>
                </label>
                <app-select [identifier]="'register-system-environment'" [singleItemSize]="35"
                  [options]="environmentOptions" [label]="undfined" i18n-placeholder placeholder="Select an environment"
                  [isMultiSelect]="true" (multiSelected)="onEnvironmentSelected($event)"
                  (toggleMenu)="adjustHeight($event)" [maxHeight]="'130px'" [readonly]="!selectedSystem.isOnline">
                </app-select>
              </div>
            </div>
          </div>
          <div class="ot-row"
            [ngClass]="{'ot-pt-6--is-half-step': isEnvDropDownOpened && environmentOptions.length > 2, 'ot-pt-4': isEnvDropDownOpened && environmentOptions.length == 2, 'ot-pt-2': isEnvDropDownOpened && environmentOptions.length == 1}">
            <div class="ot-row__column ot-row__column--is-40">
              <app-checkbox [identifier]="'register-system-agree'" formControlName="agreeFormCtrl" i18n-label
                [label]="'I agree to register this system'" i18n-arialabel
                [arialabel]="'I agree to register this system'">
              </app-checkbox>
            </div>
          </div>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</form>
}